function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.78125 15.5234H12.9336C14.5859 15.5234 15.5469 14.5625 15.5469 12.9102V7.05078C15.5469 6.05469 14.7852 5.35156 13.7773 5.35156C12.7695 5.35156 12.0078 6.05469 12.0078 7.05078V7.49609L12.2656 9.80469L10.6367 8.09375L8.08203 5.51562C7.75391 5.17578 7.29688 5 6.82812 5C5.73828 5 5 5.78516 5 6.86328C5 7.33203 5.21094 7.74219 5.53906 8.07031L8.11719 10.6367L9.83984 12.2539L7.46094 11.9961H6.78125C5.78516 11.9961 5.07031 12.7578 5.07031 13.7656C5.07031 14.7734 5.77344 15.5234 6.78125 15.5234ZM18.6055 26.6445C19.6133 26.6445 20.375 25.9414 20.375 24.9336V24.4531L20.1172 22.1445L21.7344 23.8555L24.3125 26.457C24.6523 26.7969 25.1094 26.9727 25.5781 26.9727C26.668 26.9727 27.4062 26.1875 27.4062 25.1094C27.4062 24.6406 27.1953 24.2305 26.8672 23.9023L24.2656 21.3125L22.543 19.6953L24.9102 19.9531H25.6367C26.6445 19.9531 27.3477 19.1914 27.3477 18.1836C27.3477 17.1758 26.6445 16.4258 25.6367 16.4258H19.4492C17.7969 16.4258 16.8359 17.3867 16.8359 19.0391V24.9336C16.8359 25.9414 17.5977 26.6445 18.6055 26.6445Z",
  fill: "#D5D7DE"
});

var SvgOrignalsize = function SvgOrignalsize(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOrignalsize, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/orignalsize.fe40149c.svg";
export { ForwardRef as ReactComponent };